type FooterProps = {
  text: string;
};

export function Footer({ text }: FooterProps) {
  return <footer className="bio-footer">{text}</footer>;
}
